import React from 'react';

export default class PAYEarned extends React.Component {
  render(): React.ReactNode {
    return (<b><span style={{ color: 'black' }}>PAY</span><span className="payearned-blue">earned</span></b>);
  }
}
